import { render } from "./LabelExportModal.vue?vue&type=template&id=4f8e8579&scoped=true"
import script from "./LabelExportModal.vue?vue&type=script&lang=js"
export * from "./LabelExportModal.vue?vue&type=script&lang=js"

import "./LabelExportModal.vue?vue&type=style&index=0&id=4f8e8579&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8e8579"]])

export default __exports__